<template>
  <div>
    <table class="table table-hover">
      <thead class="bg-primary text-white">
      <tr>
        <th>Nosaukums</th>
        <th class="text-center">Priekšmetu skaits</th>
        <th class="text-center">Autors</th>
        <th class="text-right">Darbības</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="list in lists">
        <td>{{list.title}}</td>
        <td class="text-center">{{list.items_count}}</td>
        <td class="text-center">{{list.user.firstname}} {{list.user.lastname}}</td>
        <td class="text-left">
          <div class="itemActions">
            <a :href="'/researcher/show/'+list.id" class="action view"><span class="material-icons">visibility</span></a>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <div v-if="lists.length === 0 && loading == false" class="alert alert-info text-center">
      Jums nav neviens priekšmetu saraksts. Izveidojiet jaunu, lai tam pievienotu priekšmetus.
    </div>
  </div>
</template>

<script>
export default{
  props:['list_type','user'],
  mounted()
  {
    this.loading = true;
    this.getResearchersLists();
  },
  data()
  {
    return{
      loading:false,
      title:"",
      errors:[],
      lists:[]
    }
  },
  methods:{
    getResearchersLists() {
      var that = this;
      axios.post('/researcher/get-user-lists',{
        list_type: that.$props.list_type,
      }).then(response =>{
        that.lists = response.data.lists;
      });
    },
    create()
    {
      var that = this;
      axios.post('/researcher/create',{
        title: this.title
      }).then(response =>{
        if(response.data.status == 'ok')
        {
          that.loading = false;
          that.$toast.open(response.data.message);
          $('#modal-new').modal('hide');
          that.title="";
          that.getResearchersLists();
        }
        else {
          that.errors = response.data.errors;
          that.$toast.error(response.data.message);
        }
        that.loading = false;
      })
    },
    deleteList(id)
    {
      var that = this;
      var that = this;
      that.$swal.fire({
        title: 'Vai tiešām vēlaties dzēst pētnieku sarakstu?',
        text: "Saraksts un tam piesaistītie priekšmeti tiks dzēsti.",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#E53935',
        cancelButtonColor: '#888787',
        confirmButtonText: 'Dzēst',
        cancelButtonText: 'Atcelt'
      }).then((result) => {
        if (result.value) {
          axios.post('/researcher/delete/' + id).then(response => {
            if (response.data.status == 'ok') {
              that.lists = response.data.lists;
              that.$toast.open(response.data.message);
            } else {
              that.$toast.error(response.data.message);
            }
          });
        }});
    }
  }
}
</script>

<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';
.actions{
  display:flex;
  justify-content: flex-end;
  margin-bottom:20px;
}
.itemActions{
  width:150px;
  display:flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  .action{
    cursor:pointer;
    padding:5px 15px;
    &.view{
      color:$blue;
    }
    &.delete{
      color:$red;
    }
  }
}
</style>
